<template>
    <ul class="skeleton">
        <li v-for="index in 5" :key="index" class="skeleton_item">
            <!-- 头图 -->
            <div class="image"></div>

            <!-- 标题 -->
            <div class="title"></div>
            <div class="title"></div>
            <div class="title" style="width: 200px"></div>

            <!-- 作者 -->
            <div class="author" style="width: 67px"></div>

            <!-- 内容 -->
            <div class="text"></div>
            <div class="text"></div>
            <div class="text"></div>
            <div class="text"></div>
            <div class="text" style="width: 200px"></div>

            <!-- 展开按钮 -->
            <div class="expand_btn" style="width: 92px"></div>
        </li>
    </ul>
</template>

<style lang="scss" scoped>
@use './Skeleton.scss';
</style>
